import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/builds/synthese-et-medias/data-center-front/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/builds/synthese-et-medias/data-center-front/layouts/default.vue").then(m => m.default || m))
}